
const digest = '1f700ae68c8a4498ef22b0d83619132ca637bdc1eceb3db7f5480c9478fca7ec';
const classes = {"wrapper":"_wrapper_1mazf_1","options":"_options_1mazf_8","seenWrapper":"_seenWrapper_1mazf_17","list":"_list_1mazf_21"};
const css = `._wrapper_1mazf_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
}
._wrapper_1mazf_1 ._options_1mazf_8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1mazf_1 ._options_1mazf_8 ._seenWrapper_1mazf_17 {
  display: flex;
  gap: 5px;
}
._wrapper_1mazf_1 ._list_1mazf_21 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_1mazf_1 ._list_1mazf_21::-webkit-scrollbar {
  display: block;
}
._wrapper_1mazf_1 ._list_1mazf_21::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1mazf_1 ._list_1mazf_21::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1mazf_1 ._list_1mazf_21::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1mazf_1 ._list_1mazf_21::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  